import type { RootState } from '../../../store/types'
import { Guest } from '../../axios/pms/guests/types'

export const selectRoomChargeOrderId = (state: RootState): string | null =>
	state.roomCharge?.orderId ?? null

export const selectRoomChargeGuests = (state: RootState): Guest[] =>
	state.roomCharge?.guests ?? []

export const selectRoomChargeGuestsAreLoading = (state: RootState): boolean =>
	!!state.roomCharge?.guestsAreLoading

export const selectRoomChargeIsProcessing = (state: RootState): boolean =>
	!!state.roomCharge?.isProcessing

export const selectRoomChargeErrorCode = (state: RootState): string | null =>
	state.roomCharge?.errorCode ?? null
